import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useBrowserHistory } from '@Utilities/services/hooks/useBrowserHistory';
import { LoadingButton as MUIButton } from '@mui/lab';
import { sizeMap, variantPropMap } from './services';
import ButtonSuccessIcon from './components/ButtonSuccessIcon';
import useButton from './hooks/useButton';
import './styles/button.scss';
import './styles/buttonV2.scss';

export default function Button({
  setHideHeader,
  children,
  variant = 'filled',
  className: propClassName,
  href,
  Img,
  SecondaryImg,
  isExternalLink = false,
  onClick,
  isLoading,
  isActive,
  isSuccess,
  onSuccess,
  buttonRef,
  disabled,
  size = 'medium',
  prevPath,
  endIcon,
  ...buttonProps
}) {
  const browserHistory = useBrowserHistory();
  const MUIButtonProps = (variant && variantPropMap[variant]) || variantPropMap['filled'];
  const MUIButtonSizeProps = (size && sizeMap[size]) || sizeMap['medium'];
  const { className, isLoadingClassName, isSuccessClassName, ...otherMUIButtonProps } = MUIButtonProps || {};
  const { className: sizeClassName } = MUIButtonSizeProps || {};
  const isSuccessState = isSuccess && !isLoading;

  useButton({ onSuccess, isSuccess });

  function handleButtonClick(e) {
    if (!isExternalLink) {
      if (href) {
        e.preventDefault && e.preventDefault();
        browserHistory.push({ pathname: href, state: { prevPath } });
        setHideHeader && setHideHeader(false);
      }
      onClick && onClick(e);
    }
  }
  return (
    <MUIButton
      {...otherMUIButtonProps}
      className={`button ${className} ${sizeClassName || ''} ${isLoading ? isLoadingClassName : ''} ${isSuccessState ? isSuccessClassName : ''} ${propClassName || ''}`}
      onClick={handleButtonClick}
      href={href}
      ref={buttonRef}
      disableFocusRipple
      disableTouchRipple
      aria-busy={isLoading}
      disabled={disabled}
      loading={isLoading}
      startIcon={
        Img && (
          <Fragment>
            {typeof Img === 'string' ? (
              <img
                className='mainIcon'
                src={Img}
                alt='mainIcon'
              />
            ) : (
              Img && <Img />
            )}
            {typeof SecondaryImg === 'string' ? (
              <img
                className='secondaryIcon'
                src={SecondaryImg}
                alt='secondaryIcon'
              />
            ) : (
              SecondaryImg && <SecondaryImg />
            )}
          </Fragment>
        )
      }
      endIcon={
        typeof endIcon === 'string' ? (
          <img
            className='endIcon'
            src={endIcon}
            alt='endIcon'
          />
        ) : (
          endIcon && <endIcon />
        )
      }
      size={size}
      {...buttonProps}
    >
      {isSuccessState ? (
        <ButtonSuccessIcon
          size={size}
          variant={variant}
        />
      ) : (
        children
      )}
    </MUIButton>
  );
}

Button.propTypes = {
  setHideHeader: PropTypes.func,
  children: PropTypes.node,
  variant: PropTypes.string,
  className: PropTypes.string,
  Img: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  SecondaryImg: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  href: PropTypes.string,
  size: PropTypes.string,
  isExternalLink: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSuccess: PropTypes.bool,
  onSuccess: PropTypes.func,
  isActive: PropTypes.bool,
  prevPath: PropTypes.string,
  endIcon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  buttonRef: PropTypes.object
};
